import React from "react";

import Stack from "@mui/material/Stack";
import Pagination from "@mui/material/Pagination";

function PageNumbers({ totalPages, paginate }) {
  const handleChange = function(event, i) {
    paginate(i); // send page number clicked back to parent RecipeResults component
  };

  return (
    <>
      <Stack alignItems="center" my={3}>
        <Pagination count={totalPages} onChange={handleChange} variant="outlined" />
      </Stack>
    </>
  );
}

export default PageNumbers;